<template>
    <div class="btn_bottom_wrap">
        <button type="button" class="btn_primary" >{{ $t('alarm.price.save') }}</button>
    </div>
</template>

<script>
    export default {
        name:"ModalBtn"
    }
</script>